@if (showZuruecksetzen$ | async) {
  <button
    type="button"
    class="now-btn now-btn-tertiary"
    (click)="facettenResetService.resetFilter()"
    id="reset-facetten"
  >
    Alle zurücksetzen
  </button>
}
